export const IS_REFRESHING = 'herdList/IS_REFRESHING';

export const LIST_REQUEST = 'herdList/LIST_REQUEST';
export const LIST_SUCCESS = 'herdList/LIST_SUCCESS';
export const LIST_FAILURE = 'herdList/LIST_FAILURE';

export const SAVE_REQUEST = 'herdList/SAVE_REQUEST';

export const REFRESH_SUCCESS = 'herdList/REFRESH_SUCCESS';
